/**
 * Module-level registry mapping toast keys to imperative callbacks.
 *
 * Keeps Redux state serializable: the Toast object in Redux stores only a
 * plain `action` string; the actual callback lives here, keyed by the same
 * toast key. Toasts.tsx looks up the callback when the action button is clicked.
 */
type ToastCallback = () => void | Promise<void>;

const registry = new Map<string, ToastCallback>();

export const registerToastCallback = (key: string, callback: ToastCallback): void => {
  registry.set(key, callback);
};

export const invokeToastCallback = (key: string): void => {
  const callback = registry.get(key);
  if (callback) {
    registry.delete(key);
    Promise.resolve()
      .then(() => callback())
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error('Toast callback failed', err);
      });
  }
};

export const clearToastCallback = (key: string): void => {
  registry.delete(key);
};
